import store from '../../store/index'



export const tilesUrl = process.env.NODE_ENV === "development" ? '' : '/wisdom_building'
export const BASEURL = process.env.NODE_ENV === "development" ? 'https://local.vrmaker.vip:37086' : 'https://local.vrmaker.vip:37086'
// export const BASEURL = process.env.NODE_ENV === "development" ? 'http://192.168.33.249' : 'http://10.10.1.198:37086'
